import http from "../../backend/http.js";

async function getItems(url) {
  try {
    const response = await http.get(url);
    return response.data;
  } catch (err) {
    throw err;
  }
}

export { getItems };